import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';
import ProductCard from 'components/modules/public/products/ProductCard';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageProductSectionProduct: FunctionComponent<Props> = ({ product, content }) => {
    return (
        <StyledComponent className="public-page-product-section-product">
            <LayoutContainer>
                <ProductCard
                    product={product}
                    content={content}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageProductSectionProduct;